import Parse, { User } from 'parse'
import moment from 'moment-timezone'
import { param } from 'jquery';

moment.tz.setDefault('America/Mexico_City');

class Country extends Parse.Object {
  constructor() {
    super('Country');
  }

  get createdAt () {
    return this.get('createdAt')
  }

  get name () {
    return this.get('name')
  }

  dump () {
    console.log(this)
  }
}

export default Country
